import { c as _c } from "react/compiler-runtime";
import { IcoPlusSmall16 } from '@onefootprint/icons';
import { LinkButton } from '@onefootprint/ui';
import { useTranslation } from 'react-i18next';
import { InlineText } from '../../components/shared/inline-edit';
import GhostRulesGroup from '../../components/suggestion/ghost-rules-group';
import RulesGroupSuggestions from '../../components/suggestion/rules-group-suggestions';
import { useBuilder } from '../../store/provider';
import { useNewGroupSuggestions } from '../../store/suggestions';
import type { RulesNode } from '../../store/types';
import { uid } from '../../store/utils';
import GroupCard from './group-card';
const RulesCode = t0 => {
  const $ = _c(49);
  const {
    rulesNode
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "agentBuilder.canvas.rules"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("agents", t1);
  const {
    actions,
    isReadOnly
  } = useBuilder();
  const canEdit = !isReadOnly;
  const newGroupSuggestions = useNewGroupSuggestions(rulesNode.id);
  let t2;
  if ($[1] !== newGroupSuggestions.length || $[2] !== rulesNode.groups || $[3] !== rulesNode.id || $[4] !== t) {
    let t3;
    if ($[6] !== newGroupSuggestions.length || $[7] !== rulesNode.groups.length || $[8] !== rulesNode.id || $[9] !== t) {
      t3 = (g, i) => <div key={g.id} className="flex flex-col"><GroupCard rulesNodeId={rulesNode.id} group={g} canUp={i > 0} canDown={i < rulesNode.groups.length - 1} canRemove={rulesNode.groups.length > 1}><RulesGroupSuggestions rulesNodeId={rulesNode.id} group={g} /></GroupCard><div className="py-2 pl-3 ml-3 border-l border-tertiary text-caption-1 text-tertiary">{i < rulesNode.groups.length - 1 || newGroupSuggestions.length > 0 ? t(_temp) : t(_temp2)}</div></div>;
      $[6] = newGroupSuggestions.length;
      $[7] = rulesNode.groups.length;
      $[8] = rulesNode.id;
      $[9] = t;
      $[10] = t3;
    } else {
      t3 = $[10];
    }
    t2 = rulesNode.groups.map(t3);
    $[1] = newGroupSuggestions.length;
    $[2] = rulesNode.groups;
    $[3] = rulesNode.id;
    $[4] = t;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[11] !== newGroupSuggestions || $[12] !== t) {
    let t4;
    if ($[14] !== newGroupSuggestions.length || $[15] !== t) {
      t4 = (s, i_0) => <div key={s.id} className="flex flex-col"><GhostRulesGroup suggestion={s} /><div className="py-2 pl-3 ml-3 border-l border-tertiary text-caption-1 text-tertiary">{i_0 < newGroupSuggestions.length - 1 ? t(_temp3) : t(_temp4)}</div></div>;
      $[14] = newGroupSuggestions.length;
      $[15] = t;
      $[16] = t4;
    } else {
      t4 = $[16];
    }
    t3 = newGroupSuggestions.map(t4);
    $[11] = newGroupSuggestions;
    $[12] = t;
    $[13] = t3;
  } else {
    t3 = $[13];
  }
  let t4;
  if ($[17] !== t) {
    t4 = t(_temp5);
    $[17] = t;
    $[18] = t4;
  } else {
    t4 = $[18];
  }
  let t5;
  if ($[19] !== t4) {
    t5 = <span className="shrink-0 text-body-2 text-tertiary">{t4}</span>;
    $[19] = t4;
    $[20] = t5;
  } else {
    t5 = $[20];
  }
  const t6 = rulesNode.defaultValue;
  let t7;
  if ($[21] !== t) {
    t7 = t(_temp6);
    $[21] = t;
    $[22] = t7;
  } else {
    t7 = $[22];
  }
  let t8;
  if ($[23] !== t) {
    t8 = t(_temp7);
    $[23] = t;
    $[24] = t8;
  } else {
    t8 = $[24];
  }
  let t9;
  if ($[25] !== actions.rules || $[26] !== rulesNode.id) {
    t9 = next => actions.rules.updateNode(rulesNode.id, {
      defaultValue: next
    });
    $[25] = actions.rules;
    $[26] = rulesNode.id;
    $[27] = t9;
  } else {
    t9 = $[27];
  }
  let t10;
  if ($[28] !== canEdit || $[29] !== rulesNode.defaultValue || $[30] !== t7 || $[31] !== t8 || $[32] !== t9) {
    t10 = <InlineText value={t6} ariaLabel={t7} placeholder={t8} canEdit={canEdit} onChange={t9} />;
    $[28] = canEdit;
    $[29] = rulesNode.defaultValue;
    $[30] = t7;
    $[31] = t8;
    $[32] = t9;
    $[33] = t10;
  } else {
    t10 = $[33];
  }
  let t11;
  if ($[34] !== t10 || $[35] !== t5) {
    t11 = <div className="flex items-center gap-2 rounded border border-tertiary bg-secondary p-2">{t5}{t10}</div>;
    $[34] = t10;
    $[35] = t5;
    $[36] = t11;
  } else {
    t11 = $[36];
  }
  let t12;
  if ($[37] !== t11 || $[38] !== t2 || $[39] !== t3) {
    t12 = <div className="flex flex-col">{t2}{t3}{t11}</div>;
    $[37] = t11;
    $[38] = t2;
    $[39] = t3;
    $[40] = t12;
  } else {
    t12 = $[40];
  }
  let t13;
  if ($[41] !== actions.rules || $[42] !== canEdit || $[43] !== rulesNode.id || $[44] !== t) {
    t13 = canEdit && <div className="self-start"><LinkButton variant="caption-3" iconComponent={IcoPlusSmall16} iconPosition="left" onClick={() => actions.rules.addGroup(rulesNode.id, uid("rgrp"))}>{t(_temp8)}</LinkButton></div>;
    $[41] = actions.rules;
    $[42] = canEdit;
    $[43] = rulesNode.id;
    $[44] = t;
    $[45] = t13;
  } else {
    t13 = $[45];
  }
  let t14;
  if ($[46] !== t12 || $[47] !== t13) {
    t14 = <>{t12}{t13}</>;
    $[46] = t12;
    $[47] = t13;
    $[48] = t14;
  } else {
    t14 = $[48];
  }
  return t14;
};
export default RulesCode;
function _temp($) {
  return $.elseIf;
}
function _temp2($_0) {
  return $_0.else;
}
function _temp3($_1) {
  return $_1.elseIf;
}
function _temp4($_2) {
  return $_2.else;
}
function _temp5($_3) {
  return $_3.defaultValue.label;
}
function _temp6($_4) {
  return $_4.defaultValue.label;
}
function _temp7($_5) {
  return $_5.defaultValue.placeholder;
}
function _temp8($_6) {
  return $_6.addGroup;
}